<div class="disable-header-footer">
  <app-header-latest></app-header-latest>
</div>

<div class="exam-container" *ngIf="selectedExam && !examStarted && !examSubmitted">
  <div class="exam-card">
    <div class="exam-header">
      <img src="assets/images/Exampad.svg" alt="Exam Icon" class="exam-icon" />
      <h1>ONLINE EXAM</h1>
    </div>

    <h3 class="exam-title">{{ selectedExam.title }}</h3>

    <!-- Candidate Info -->
    <div class="exam-avatar" *ngIf="isValidated">
      <h3 class="exam-title">Welcome</h3>
      <div class="candidate-info">
        <img [src]="avatarPath ? avatarPath : 'assets/images/default1.jpg'" alt="Candidate Photo"
          class="candidate-photo" />
        <h5 style="text-align: center;" class="primary-color">{{ candidateName }}</h5>
        <p>
          <strong>Exam Date:</strong> {{ scheduledDate | date:'longDate' }} |
          <strong>Time:</strong> {{ scheduledTime }}
        </p>
        <div class="col-md-12 text-center">
          <p [ngStyle]="{'font-weight': '700', 'font-size': '1.2rem'}">
            <span *ngIf="examStatusText.includes('Exam will start')">
              Exam will start in :
              <span style="color:var(--primary-color); font-size:1.3rem;">
                {{ examStatusText.split('Exam will start ')[1] }}
              </span>
            </span>

            <span *ngIf="!examStatusText.includes('Exam will start ')"
              [ngStyle]="{'color': isExamExpired ? 'var(--primary-color)' : 'black'}">
              {{ examStatusText }}
            </span>
          </p>

        </div>
      </div>
    </div>

    <div class="exam-details">
      <p>
        <strong><i class="fa fa-clock-o primary-color"></i> Duration: </strong>
        <span class="primary-color">{{ selectedExam.duration }}</span> mins |
        <strong><i class="fa fa-book primary-color"></i> Total Marks: </strong>
        <span class="primary-color">{{ selectedExam.total_marks }}</span> |
        <strong><i class="fa fa-check-circle primary-color"></i> Pass Marks: </strong>
        <span class="primary-color">{{ selectedExam.pass_marks }}</span> |
        <strong><i class="fa fa-question-circle primary-color"></i> Questions: </strong>
        <span class="primary-color">#{{ examQuestions.length }}</span> |
        <strong><i class="fa fa-refresh primary-color"></i> Attempts: </strong>
        <span class="primary-color">#{{ selectedExam.no_of_attempts }}</span>
      </p>
    </div>
    <div class="exam-detail-header">
      <h3>About Exam</h3>
      <p class="exam-text">
        {{ decodeHtml(selectedExam.description) }}
      </p>
    </div>

    <div class="exam-detail-header">
      <h3>Instructions</h3>
      <p class="exam-text">
        {{ decodeHtml(selectedExam.info_candidate) }}
      </p>
    </div>




    <p style="color: #000;">Please ensure you have a stable internet connection</p>

    <!-- Validation Button -->
    <div class="row" *ngIf="!login_required && !isValidated">
      <div class="col-md-12 text-center">
        <button class="btn btn-solid" (click)="handleButtonClick()" style="min-width: 150px;">
          Validate
        </button>
      </div>
    </div>

    <div class="row" *ngIf="login_required && !isValidated">
      <div class="col-md-12 text-center">
        <button class="btn btn-solid" (click)="handleLogin()" style="min-width: 150px;">
          Continue
        </button>
      </div>
    </div>

    <!-- <div class="row" *ngIf="!isValidated">
      <div class="col-md-12 text-center">
        <button class="btn btn-solid" (click)="handleButtonClick()" style="min-width: 150px;">
          Validate
        </button>
      </div>
    </div> -->

    <!-- Status / Start Button -->
    <div *ngIf="isValidated">
      <button [disabled]="!isExamStartAvailable" class="btn btn-solid" (click)="handleStartExam()">
        Start Exam
      </button>

      <!-- <button [disabled]="!isExamStartAvailable" class="btn btn-solid" (click)="handleStartExam()">
          Start Exam
        </button> -->

    </div>

  </div>
</div>

<div *ngIf="examStarted && !examSubmitted" class="exam-session">
  <div class="exam-header">
    <h2>{{ selectedExam.title }}</h2>
    <div class="exam-info">
      <span class="time-left">⏱ Time Left: <strong [ngClass]="{'time-up': isTimeUp}">{{ displayTime }}</strong></span>
      <span class="total-marks">Total Marks: {{ selectedExam.total_marks }}</span>
      <span *ngIf="selectedExam.display_mode === 'ONE_BY_ONE'">
        Question: {{ currentIndex + 1 }}/{{ examQuestions.length }}
      </span>
    </div>
  </div>

  <form (ngSubmit)="handleSubmitExam()">

    <!-- ALL MODE -->
    <div *ngIf="selectedExam.display_mode === 'ALL'">
      <div class="question-grid">
        <div *ngFor="let question of examQuestions | slice:(currentPage*10):(currentPage*10+10); let i=index"
          class="question-card">
          <!-- ✅ Question text + marks on the right -->
          <div class="question-header">
            <h4>Q{{ currentPage*10 + i + 1 }}. {{ question.question_text }}</h4>
            <span class="question-marks">Marks: {{ question.total_marks }}</span>
          </div>
          <p class="note-text">{{ question.note }}</p>


          <!-- Single / Boolean -->
          <mat-radio-group *ngIf="question.question_type === 'SINGLE'" [value]="selectedAnswers[question.id]"
            (change)="submitAnswer(question.id, $event.value)" class="custom-radio">
            <div class="options-grid">
              <mat-radio-button *ngFor="let option of question.options" [value]="option.id">
                {{ option.option_text }}
              </mat-radio-button>
            </div>
          </mat-radio-group>
          <!-- ✅ BOOLEAN type (horizontal layout) -->
          <mat-radio-group *ngIf="question.question_type === 'BOOLEAN'" [value]="selectedAnswers[question.id]"
            (change)="submitAnswer(question.id, $event.value)" class="custom-radio boolean-options">
            <mat-radio-button *ngFor="let option of question.options" [value]="option.id">
              {{ option.option_text }}
            </mat-radio-button>
          </mat-radio-group>

          <!-- Multiple -->
          <div *ngIf="question.question_type === 'MULTIPLE'">
            <div class="options-grid">
              <mat-checkbox *ngFor="let option of question.options"
                [checked]="selectedAnswers[question.id]?.includes(option.id)"
                (change)="submitAnswer(question.id, option.id, $event.checked)">
                {{ option.option_text }}
              </mat-checkbox>
            </div>
          </div>
          <p class="note-text"><i>{{question.question_instructions }}</i></p>
        </div>
      </div>

      <div class="pagination-buttons">
        <button type="button" *ngIf="currentPage > 0" class="secondary-btn-round" (click)="prevPage()"
          [disabled]="currentPage === 0 || isTimeUp">Previous</button>
        <button type="button" *ngIf="(currentPage + 1) * questionsPerPage < examQuestions.length"
          class="secondary-btn-round" (click)="nextPage()"
          [disabled]="(currentPage+1)*10 >= examQuestions.length || isTimeUp">Next</button>
        <button *ngIf="(currentPage + 1) * questionsPerPage >= examQuestions.length" type="submit" class="btn btn-solid"
          [disabled]="isTimeUp">Submit Exam</button>
      </div>
      <!-- ✅ Message when time is up -->
      <div *ngIf="isTimeUp" class="timeup-message">
        ⏰ <strong>Time’s over!</strong> The exam is now locked.
      </div>
    </div>

    <!-- ONE_BY_ONE MODE -->
    <div *ngIf="selectedExam.display_mode === 'ONE_BY_ONE' && examQuestions.length">
      <div class="question-card">
        <!-- ✅ Question text + marks on the right -->
        <div class="question-header">
          <h4>Q{{ currentIndex + 1 }}. {{ examQuestions[currentIndex].question_text }}</h4>
          <span class="question-marks">Marks: {{ examQuestions[currentIndex].total_marks }}</span>
        </div>
        <p class="note-text">{{ examQuestions[currentIndex].note }}</p>


        <mat-radio-group *ngIf="examQuestions[currentIndex].question_type === 'SINGLE'"
          [value]="selectedAnswers[examQuestions[currentIndex].id]"
          (change)="submitAnswer(examQuestions[currentIndex].id, $event.value)" class="custom-radio">
          <div class="options-grid">
            <mat-radio-button *ngFor="let option of examQuestions[currentIndex].options" [value]="option.option_text">
              {{ option.option_text }}
            </mat-radio-button>
          </div>
        </mat-radio-group>
        <!-- ✅ BOOLEAN -->
        <mat-radio-group *ngIf="examQuestions[currentIndex].question_type === 'BOOLEAN'"
          [value]="selectedAnswers[examQuestions[currentIndex].id]"
          (change)="submitAnswer(examQuestions[currentIndex].id, $event.value)" class="custom-radio boolean-options">
          <mat-radio-button *ngFor="let option of examQuestions[currentIndex].options" [value]="option.option_text">
            {{ option.option_text }}
          </mat-radio-button>
        </mat-radio-group>

        <div *ngIf="examQuestions[currentIndex].question_type === 'MULTIPLE'">
          <div class="options-grid">
            <mat-checkbox *ngFor="let option of examQuestions[currentIndex].options"
              [checked]="selectedAnswers[examQuestions[currentIndex].id]?.includes(option.id)"
              (change)="submitAnswer(examQuestions[currentIndex].id, option.id, $event.checked)">
              {{ option.option_text }}
            </mat-checkbox>
          </div>
        </div>
        <p class="note-text"><i>{{ examQuestions[currentIndex].question_instructions }}</i></p>
      </div>

      <div class="navigation-buttons">
        <button type="button" *ngIf="currentIndex > 0" class="secondary-btn-round" (click)="prevQuestion()"
          [disabled]="currentIndex === 0 || isTimeUp">Previous</button>
        <button type="button" *ngIf="currentIndex < examQuestions.length - 1" class="btn btn-solid"
          (click)="nextQuestion()" [disabled]="currentIndex === examQuestions.length - 1 || isTimeUp">Next</button>
        <button *ngIf="currentIndex === examQuestions.length - 1" type="submit" class="btn btn-solid"
          [disabled]="isTimeUp">Submit</button>
      </div>
      <!-- ✅ Message when time is up -->
      <div *ngIf="isTimeUp" class="timeup-message">
        ⏰ <strong>Time’s over!</strong> The exam is now locked.
      </div>
    </div>
  </form>
</div>
<app-success-online-exam *ngIf="examSubmitted && !showVerificationView" [result]="result"
  [candidateName]="candidateName" (retake)="retakeExam()" (verify)="showVerificationView = true">
</app-success-online-exam>

<div *ngIf="showVerificationView" class="review-container">
  <h2 class="review-title">Review Your Answers</h2>

  <div *ngFor="let q of examQuestions; let i = index" class="question-card">
    <div class="question-header">
      <h4>Q{{ i + 1 }}. {{ q.question_text }}</h4>
      <div class="marks">
        <span class="badge">
          {{ getAnswer(q.id)?.user_obtained_marks || 0 }}/{{ getAnswer(q.id)?.q_total_marks || 0 }} marks
        </span>
      </div>
    </div>

    <div class="options">
      <div *ngFor="let opt of q.options" [ngClass]="{
          'correct-option': isCorrectOption(q.id, opt.id),
          'wrong-option': isWrongOption(q.id, opt.id),
          'disabled-option': !isUserSelected(q.id, opt.id) && !isCorrectOption(q.id, opt.id) && !isWrongOption(q.id, opt.id)
        }" class="option-item">
        <label>
          <input [type]="getInputType(q)" [checked]="isUserSelected(q.id, opt.id)" [disabled]="true" [ngClass]="{
        'input-correct': isCorrectOption(q.id, opt.id),
        'input-wrong': isWrongOption(q.id, opt.id),
         'input-disabled': !isCorrectOption(q.id, opt.id) &&
                          !isWrongOption(q.id, opt.id)
      }" name="question{{ q.id }}" />
          <span>{{ opt.option_text }}</span>
        </label>

      </div>
    </div>
  </div>

  <div class="review-actions">
    <button class="btn btn-solid" (click)="closeReview()">Close Review</button>
  </div>
</div>



<!-- ✅ Validation Popup Template -->
<ng-template #validationDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="text-center" style="position: relative;">
    User Validation
    <button class="close-btn" mat-icon-button (click)="dialogRef.close(false)"
      style="position: absolute; right: 16px; top: 12px;">
      <!-- <mat-icon>close</mat-icon> -->
    </button>
  </h2>

  <mat-dialog-content class="mt-3">
    <form [formGroup]="validationForm">
      <div class="row"></div>
      <div class="form-group form-group-change">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="Enter your email" />
          <mat-error *ngIf="validationForm.get('email')?.hasError('required')">
            Username is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row"></div>

      <div class="form-group form-group-change" style="position: relative;">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Password</mat-label>
          <input matInput [type]="vendorPasswordhide ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your password" />
          <mat-error *ngIf="validationForm.get('password')?.hasError('required')">
            Password is required
          </mat-error>
        </mat-form-field>

        <!-- Eye icon -->
        <i class="fa" [ngClass]="vendorPasswordhide ? 'fa-eye-slash' : 'fa-eye'"
          (click)="vendorPasswordhide = !vendorPasswordhide" style="
              position: absolute;
              top: 40%;
              right: 20px;
              transform: translateY(-50%);
              cursor: pointer;
              color: var(--primary-color);
              font-size: 18px;
            "></i>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="padding: 3%;">
    <button class="btn btn-solid" (click)="validateUserOnlineExam(dialogRef)" [disabled]="validationForm.invalid">
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>
<ng-template #userValidationDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="text-center" style="position: relative;">
    User Registration
    <button mat-icon-button class="close-btn" (click)="dialogRef.close()"
      style="position:absolute; right:16px; top:12px;">
      <!-- <mat-icon>close</mat-icon> -->
    </button>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="userValidationForm">

      <!-- Username -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Name</mat-label>
        <input type="text" matInput formControlName="name">
        <mat-error *ngIf="userValidationForm.get('name')?.hasError('required')">
          Name is required
        </mat-error>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Email</mat-label>
        <input type="text" matInput formControlName="email">
        <mat-error *ngIf="userValidationForm.get('email')?.hasError('required')">
          Email is required
        </mat-error>
      </mat-form-field>

      <!-- Mobile -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Mobile Number</mat-label>
        <input type="number" matInput formControlName="mobile" maxlength="10">
        <mat-error *ngIf="userValidationForm.get('mobile')?.hasError('pattern')">
          Enter valid 10-digit mobile number
        </mat-error>
      </mat-form-field>

      <!-- Anonymous Checkbox -->
      <mat-checkbox formControlName="anonymous_name_status">
        Display name as anonymous
      </mat-checkbox>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="margin: 2%;">
    <button class="btn btn-solid" [disabled]="userValidationForm.invalid" (click)="submitValidation(dialogRef)">
      Submit
    </button>
  </mat-dialog-actions>
</ng-template>

<div class="disable-header-footer">
  <!-- <app-footer-more-info></app-footer-more-info> -->
   <app-peopleflow-footer></app-peopleflow-footer>
</div>